module.exports = __webpack_public_path__ + "img/onboarding-domain-dark.0b2149e0.svg";